// Parse total minutes into hours component
export const parseReminderHours = (value: string): string => {
  if (!value) return '';
  const total = parseInt(value, 10);
  if (isNaN(total) || total < 0) return '';
  return Math.floor(total / 60).toString();
};

// Parse total minutes into minutes component (0-59)
export const parseReminderMinutes = (value: string): string => {
  if (!value) return '';
  const total = parseInt(value, 10);
  if (isNaN(total) || total < 0) return '';
  return (total % 60).toString();
};

// Convert hours and minutes strings to total minutes
export const toTotalMinutes = (hoursStr: string, minutesStr: string): string => {
  const h = parseInt(hoursStr || '0', 10);
  const m = parseInt(minutesStr || '0', 10);
  if (isNaN(h) || isNaN(m)) return '';
  const boundedM = Math.max(0, Math.min(59, m));
  const total = Math.max(0, h) * 60 + boundedM;
  return total.toString();
};

// Convert 24hr time (HH:mm) to 12hr format (h:mm AM/PM)
export const format12Hour = (time24: string): string => {
  if (!time24) return '';

  // If already in 12-hour format, return as is
  if (time24.includes('AM') || time24.includes('PM')) {
    return time24;
  }

  const [hours, minutes] = time24.split(':').map(Number);
  if (isNaN(hours) || isNaN(minutes)) {
    return time24;
  }

  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
};

// Convert 12hr time input to 24hr format (HH:mm)
export const convert24Hour = (time12: string): string => {
  if (!time12) return '';
  const match = time12.match(/(\d+):(\d+)\s*(AM|PM)/i);
  if (!match) return time12;

  let [, hours, minutes, period] = match;
  let hours24 = parseInt(hours);

  if (period.toUpperCase() === 'PM' && hours24 !== 12) {
    hours24 += 12;
  } else if (period.toUpperCase() === 'AM' && hours24 === 12) {
    hours24 = 0;
  }

  return `${hours24.toString().padStart(2, '0')}:${minutes}`;
};

// Convert 24hr time (HH:mm) back to 12hr format for editing
export const convertTo12Hour = (time24: string): string => {
  if (!time24) return '';

  // If already in 12-hour format, return as is
  if (time24.includes('AM') || time24.includes('PM')) {
    return time24;
  }

  const [hours, minutes] = time24.split(':').map(Number);
  if (isNaN(hours) || isNaN(minutes)) {
    return '';
  }

  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
};
